import React from 'react'
import "./pageBlog.css";

import HeaderBlog6 from "../pageBlog/HeaderBlog6";
 import BodyBlog6 from "../pageBlog/BodyBlog6";
import Footer2 from "../footer2/Footer2";

function PageBlog6() {
  return (
    <section>
      
       <HeaderBlog6/>
       <BodyBlog6/>
       <Footer2/>
    </section>
  )
}

export default PageBlog6